// extracted by mini-css-extract-plugin
export default {"outerContainer":"cQthx6","container":"TWbBZH","split":"j2fho6","item":"mWxpYY","leftItem":"ev2nXi","rightItem":"NjdQIr"};